import { useQuery } from "@tanstack/react-query";
import { useApiConfig } from "@visioni/a3s-client-api/app";
import { scenariosQuery } from "@visioni/a3s-traffic-flow/app";
import { useTenant, useTenantId } from "@src/features/tenants";

const STALE_TIME_MS = 60_000;

/**
 * Lists every traffic-flow scenario the caller can access in the active
 * tenant. Built from `scenariosQuery` (= `queryFor(listScenariosEndpoint)`),
 * so the queryKey, URL, and decode boundary all derive from the single
 * `scenariosResource` definition shared with the CDK route.
 *
 * Mirrors the consumption pattern in
 * `features/a3s-media/src/app/hooks/use-clips.ts`.
 */
export const useTrafficFlowScenarios = () => {
  const apiConfig = useApiConfig();
  const tenantId = useTenantId();
  const { isLoading: isTenantLoading } = useTenant();

  const query = useQuery({
    ...scenariosQuery(apiConfig, { tenantId }),
    enabled: !!tenantId,
    staleTime: STALE_TIME_MS,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });

  return {
    ...query,
    isTenantPending: isTenantLoading || !tenantId,
  };
};
